export default __webpack_public_path__ + "static/media/logo.785fd5af.png";